"use strict";
import { mix } from "polished";
import { colors } from "theme/colors";
import { hex } from "wcag-contrast";
const MIN_COLOR_CONTRAST_THRESHOLD = 1.95;
export function passesContrast(color, backgroundColor) {
  const contrast = hex(color, backgroundColor);
  return contrast >= MIN_COLOR_CONTRAST_THRESHOLD;
}
export function getNeutralContrast(accent1) {
  return passesContrast(accent1, colors.white) ? colors.white : colors.black;
}
export function getAccent2(accent1, surface1) {
  return mix(0.12, accent1, surface1);
}
